import PropTypes from 'prop-types';
import React from 'react';
import SecureLink from 'src/common/utils/SecureLink';
import AssessmentStatus from 'src/components/Facesheet/Assessments/components/AssessmentStatus';
import { get } from 'lodash';
import './stylesheets/detail-view.scss';

export function DetailAssessments({ assessments, detailObj }) {
  const assessmentList = assessments.map((assessment = {}, i) => (
    <li className="detail-info__relationship-file" key={i}>
      <SecureLink
        securable={assessment}
        to={assessment.url}
        forceCanView={get(detailObj, '_meta._type') === 'assistancerequest'}
      >
        {assessment.form.name}
      </SecureLink>

      <span className="detail-info__assessment-status">
        (<AssessmentStatus assessment={assessment} />)
      </span>
    </li>
  ));

  return (
    <div className="detail-info__relationship">
      <h5 className="detail-info__icon-label">Assessments</h5>
      <ul className="detail-info__relationship-files list-unstyled">
        {assessmentList}
      </ul>
    </div>
  );
}

DetailAssessments.propTypes = {
  assessments: PropTypes.arrayOf(
    PropTypes.shape({
      form: PropTypes.shape({
        name: PropTypes.string.isRequired,
      }).isRequired,
      url: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
  detailObj: PropTypes.object.isRequired,
};

export default DetailAssessments;
